// extracted by mini-css-extract-plugin
module.exports = {"container":"rule_container__asK2N","content":"rule_content__1lhOq","text_mark":"rule_text_mark__2afit","text":"rule_text__1_hnR","text_gap":"rule_text_gap__3Iktg"};